import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"margin-top":"-12rem"},
  class: "w-100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Select Industry sector(s)")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["data-id", "checked"]
const _hoisted_6 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industrySectors, (is) => {
          return (_openBlock(), _createElementBlock("div", {
            key: is.id,
            class: "form-check form-check-custom form-check-solid my-3 col-md-4"
          }, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: "",
              id: "flexCheckDefault",
              "data-id": is.id,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToIndustrySectors($event))),
              checked: _ctx.checkedIndustrySectors[is.id]
            }, null, 40, _hoisted_5),
            _createElementVNode("label", _hoisted_6, _toDisplayString(is.name), 1)
          ]))
        }), 128))
      ]),
      (_ctx.isAnyIndustrySectorSelected)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Kindly select an industry sector to continue "))
        : _createCommentVNode("", true)
    ])
  ]))
}